import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { InterventiService } from '../../../services/interventi.service';
import { Rendicontazione } from '../../../models/rendicontazione.model';
import { AllegatoIntervento } from '../../../models/allegato-intervento.model';
import { DeterminaInterventoRequest } from '../../../models/requests/determina-intervento.model';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';


@Component({
  selector: 'app-comunica-determina',
  templateUrl: './comunica-determina.component.html',
  styleUrls: ['./comunica-determina.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    InputTextareaModule,
    CalendarModule,
    FileUploadModule,
    ToastModule
  ],
  providers: [MessageService, NGXLogger]
})
export class ComunicaDeterminaComponent {
  @Input() rendicontazione!: Rendicontazione | null;
  @Output() comunicaDetermina = new EventEmitter<any>();
  visible: boolean = false;
  today: Date = new Date();
  numeroDetermina: string = '';
  dataDetermina: Date | null = null;
  importoLiquidato: number | null = null;
  note: string = '';
  file: File | null = null;
  loading: boolean = false;

  constructor(
    private messageService: MessageService,
    private logger: NGXLogger,
    private interventiService: InterventiService,
    private firebaseStorageService: FirebaseStorageService
  ) {}

  show(rendicontazione: Rendicontazione) {
    this.logger.info('[COMUNICA DETERMINA] Mostra comunicazione determina', rendicontazione);
    this.rendicontazione = rendicontazione;
    if(this.rendicontazione){
      this.numeroDetermina = this.rendicontazione.numeroDetermina ?? '';
      this.importoLiquidato = this.rendicontazione.importo ?? null;
      this.note = '';
    }
    this.logger.info('[COMUNICA DETERMINA] Mostra comunicazione determina', this.rendicontazione);
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.rendicontazione = null;
    this.numeroDetermina = '';
    this.dataDetermina = null;
    this.importoLiquidato = null;
    this.note = '';
    this.file = null;

    this.reset();
  }

  reset() {
    this.numeroDetermina = '';
    this.dataDetermina = null;
    this.importoLiquidato = null;
    this.note = '';
    this.file = null;
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onFileSelect(event: any) {
    this.file = event.files[0];
  }

  onFileClear() {
    this.file = null;
  }

  async salva() {
    this.loading = true;
    this.logger.info('[COMUNICA DETERMINA] Inizio salvataggio', this.rendicontazione);

    if (!this.numeroDetermina) {
      this.loading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Inserire il numero della determina'
      });
      return;
    }

    if (!this.file) {
      this.loading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Caricare il file della determina'
      });
      return;
    }

    if (this.importoLiquidato === null || this.importoLiquidato < 0) {
      this.loading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Inserire un importo liquidato valido'
      });
      return;
    }

  /*   if (!this.rendicontazione?.intervento?.id) {
      this.logger.error('[COMUNICA DETERMINA] Rendicontazione o intervento non trovato', this.rendicontazione);
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Dati rendicontazione non validi'
      });
      return;
    } */

    const path = `interventi/${this.rendicontazione?.intervento}/determine-umvs/${this.rendicontazione?.id!}/${this.file.name}`;
    let request: DeterminaInterventoRequest = {
      numeroDetermina: this.numeroDetermina,
      dataDetermina: this.dataDetermina ? this.formatDate(this.dataDetermina) : undefined,
      importoLiquidato: this.importoLiquidato,
      note: this.note?.trim() ? this.note.trim() : null,
      allegati: []
    };
    let allegato: AllegatoIntervento = {
      id: null,
      nomeFile: this.file.name,
      percorsoFile: path,
      tipoFile: this.file.type,
      dimensioneKb: this.file.size
    };
    request.allegati!.push(allegato);

    try {
      await this.firebaseStorageService.uploadFile(this.file, path).toPromise();
      this.logger.info('[COMUNICA DETERMINA] Salvataggio file su storage OK');

      this.interventiService.comunicaDetermina(this.rendicontazione?.intervento!, this.rendicontazione?.id!, request).subscribe(
        (res: any) => {
          this.logger.info('[COMUNICA DETERMINA] Comunicazione determina completata', res);
          this.messageService.add({
            severity: 'success',
            summary: 'Successo',
            detail: 'Determina comunicata con successo'
          });
          this.loading = false;
          this.comunicaDetermina.emit();
          this.hide();
        },
        (error: any) => {
          this.logger.error('[COMUNICA DETERMINA] Errore nella comunicazione determina', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore nella comunicazione della determina'
          });
          this.loading = false;
        }
      );
    } catch (error) {
      this.logger.error('[COMUNICA DETERMINA] Errore nel salvataggio del file', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Errore nel salvataggio del file'
      });
      this.loading = false;
    }
  }
}
